module.exports = __webpack_public_path__ + "static/media/medline.a627798c.png";